import { html, unsafeCSS, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./shortcut-group.css?inline";
import "@/components/shortcut";

@customElement("eko-shortcut-group")
class ShortcutGroup extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) wrap = false;

  private renderShortcutGroup(content: TemplateResult) {
    return html` <div class="eko-shortcut-group">${content}</div> `;
  }

  render() {
    const content = html`<slot></slot>`;

    return this.renderShortcutGroup(content);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-shortcut-group": ShortcutGroup;
  }
}

export default ShortcutGroup;
